/* eslint-disable react/prefer-stateless-function */
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  NitroPanel,
  NitroIcon,
  NitroButtonGroup,
  NitroLoading,
  NitroButton,
  NitroMultipleSelect,
  NitroSingleSelect,
  NitroTextField
} from 'nitro-components';
import { SEARCHTYPE } from './store/TYPES';
import {
  getRoles,
  getEntities,
  getTimeZones,
  getRestrictions,
  getSelectedUser,
  fetchUser,
  updateUser,
  getResult,
  closeMessage
} from './store/action';
import ActionButtons from './ActionButtons';
import {
  Container,
  SearchResultStyleHeader,
  Main,
  NavContainer,
  TabContainer,
  PersonalDetailHeader,
  DetailContainer,
  DetailTitle,
  DetailContent,
  DetailEntry,
  LoginTimeDiv,
  Background,
  ResultHeader
} from './ResultStyle';
import { USERS_MANAGEMENT_USER_LISTING, INSIGHTS } from '../../routes/const';
import { SimpleHolder } from '../powerbi/EmbedDisplay';
import TimeZoneSelector from './TimeZoneSelector';
import ChangePassword from './ChangePassword';

const userBasicDetailKeyMap = {
  Username: { column: 'userName', disabled: true },
  Status: { column: 'status', disabled: true },
  'First Name': { column: 'firstName' },
  'Last Name': { column: 'lastName' },
  Mobile: { column: 'mobile' }
};

const userCompanyDetailKeyMap = {
  Company: {
    column: 'employerCompanyName',
    extraInfo: 'employerCompanyCode',
    disabled: true
  },
  'Time Zone': { column: 'zoneId', extraInfo: 'zoneName', disabled: true },
  'Business Unit': {
    column: 'businessEntityName',
    extraInfo: 'countryCode',
    disabled: true
  }
};

const userPermissionKeyMap = {
  Role: { column: 'roles' },
  'User Restrictions': { column: 'restrictions' }
};

class UserDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      show: false
    };
  }

  componentWillMount() {
    const userId = this.props.location.pathname.split('/')[3];
    this.props.fetchUser(userId);
    setTimeout(() => {
      if (
        !this.props.loading &&
        this.props.location.state &&
        this.props.location.state.editMode &&
        !this.state.editMode
      ) {
        this.setState({
          editMode: true,
          user: this.props.user,
          selectedTimeZone: this.props.user.zoneId,
          selectedRoles: this.props.user.roles.map(x => x.Id),
          selectedEntity: this.props.user.businessEntityId
        });
      }
    }, 800);
  }
  render() {
    const {
      user,
      loading,
      timeZones,
      roles,
      businessEntities,
      restrictions,
      modifyUser,
      updateResult
    } = this.props;
    const goHome = () => {
      const { router } = this.context;
      router.push(INSIGHTS);
    };
    const goUserManagement = () => {
      const { router } = this.context;
      router.push(USERS_MANAGEMENT_USER_LISTING);
    };
    const getEditField = (key, keyMap) => {
      switch (key) {
        case 'Time Zone':
          return (
            <DetailContent edit>
              <TimeZoneSelector
                timezones={timeZones}
                zoneId={this.state.selectedTimeZone}
                setTimeZone={e => {
                  this.setState({ selectedTimeZone: e.value });
                }}
              />
            </DetailContent>
          );
        case 'Role':
          return (
            <DetailContent edit permission>
              <NitroMultipleSelect
                value={this.state.selectedRoles}
                options={roles.map(x => ({
                  value: x.id,
                  label: x.name
                }))}
                action={e => this.setState({ selectedRoles: e.value })}
                disabled={keyMap[key].disabled}
              />
            </DetailContent>
          );
        case 'User Restrictions':
          return (
            <DetailContent edit={this.state.editMode}>
              {/* {restrictions.map(x => (
                <p key={x.companyCode}>
                  <span>
                    {`${x.companyCode || ''} ${x.companyName ||
                      ''} ${x.countryCode || ''} `}
                  </span>
                  <br />
                </p>
              ))} */}
            </DetailContent>
          );
        case 'Business Unit':
          return (
            <DetailContent edit>
              <NitroSingleSelect
                value={this.state.selectedEntity}
                options={businessEntities.map(x => ({
                  value: x.Id,
                  label: x.Name
                }))}
                action={e => this.setState({ selectedEntity: e.value })}
                disabled={keyMap[key].disabled}
              />
            </DetailContent>
          );
        // eslint-disable-next-line no-case-declarations
        default:
          const { user } = this.state;

          return (
            <NitroTextField
              floatingLabelText={key}
              value={
                key !== 'Status'
                  ? user[keyMap[key].column] || ''
                  : user[keyMap[key].column]
              }
              variant="base1"
              fullWidth
              onChange={e => {
                const user = { ...this.state.user };
                const modifyKey = keyMap[key].column;
                const modifyVal = e.target.value;
                user[modifyKey] = modifyVal;
                this.setState({ user });
              }}
              disabled={keyMap[key].disabled}
            />
          );
      }
    };
    const getDataField = (key, keyMap) => {
      switch (key) {
        case 'Role':
          return (
            <DetailContent edit={this.state.editMode}>
              {user[keyMap[key].column].map(e => e.Name).join(', ')}
            </DetailContent>
          );
        case 'Time Zone':
          return (
            <DetailContent edit={this.state.editMode}>
              {
                timeZones
                  .filter(x => x.zoneId == user[keyMap[key].column])
                  .map(x => {
                    const gmtOffset = x.gmtOffset / 3600;
                    return `(GMT ${gmtOffset > 0 ? '+' : '-'} ${gmtOffset}) ${
                      x.zoneName
                    }`;
                  })[0]
              }
            </DetailContent>
          );
        case 'Status':
          return (
            <DetailContent edit={this.state.editMode}>
              {user[keyMap[key].column]}
            </DetailContent>
          );
        case 'User Restrictions':
          return (
            <DetailContent edit={this.state.editMode}>
              {/* {restrictions.map(x => (
                <p key={x.companyCode}>
                  <span>{`${x.companyCode} ${x.companyName} ${x.countryCode} `}</span>
                  <br />
                </p>
              ))} */}
            </DetailContent>
          );
        default:
          return (
            <DetailContent edit={this.state.editMode}>
              {`${user[keyMap[key].column] || ''}${
                keyMap[key].extraInfo
                  ? ` - ${user[keyMap[key].extraInfo].toUpperCase()}`
                  : ''
              }` || ''}
            </DetailContent>
          );
      }
    };

    const saveChange = () => {
      const modifiedUser = {
        ...this.state.user,
        userCompanyCodes: restrictions,
        zoneId: this.state.selectedTimeZone,
        zoneName: timeZones.find(x => x.zoneId == this.state.selectedTimeZone)
          .zoneName,
        roles: roles.filter(x => this.state.selectedRoles.includes(x.id))
      };
      modifyUser(modifiedUser);
    };
    const getResultMessage = () => {
      if (updateResult) {
        setTimeout(() => {
          this.props.turnoffMessage();
        }, 5000);
      }
    };
    return (
      <Main>
        <NavContainer>
          <TabContainer onClick={goHome}>Home</TabContainer> {' / '}
          <TabContainer onClick={goUserManagement}>
            User Management
          </TabContainer>
          {' / '}
          <TabContainer onClick={goUserManagement}>Users</TabContainer>
          {' / '}
          {!this.props.loading &&
            `${this.props.user.firstName} ${this.props.user.lastName}`}
        </NavContainer>
        <Container>
          {!loading && user ? (
            <div>
              <NitroPanel>
                {getResultMessage()}
                {updateResult && (
                  <ResultHeader>
                    You have successfully saved your changes
                    <NitroIcon
                      name="close"
                      variant="primary"
                      action={() => this.props.turnoffMessage()}
                    />
                  </ResultHeader>
                )}
                <SearchResultStyleHeader>
                  {this.props.user.firstName} {this.props.user.lastName}
                  {!this.state.editMode && (
                    <div>
                      <NitroIcon
                        name="edit"
                        variant="secondary"
                        size={14}
                        right={8}
                        action={() =>
                          this.setState({
                            editMode: true,
                            user,
                            selectedTimeZone: user.zoneId,
                            selectedRoles: user.roles.map(x => x.Id),
                            selectedEntity: user.businessEntityId
                          })
                        }
                      />
                      <ActionButtons
                        rowData={user}
                        edit
                        refresh={() => {
                          this.props.fetchUser(user.userId);
                        }}
                      />
                    </div>
                  )}
                </SearchResultStyleHeader>
                <LoginTimeDiv>
                  Last Logged on:{' '}
                  {user.lastLoginTime ? user.lastLoginTime.toString() : 'N/A'}
                </LoginTimeDiv>
                <PersonalDetailHeader>PERSONAL DETAILS</PersonalDetailHeader>
                <DetailContainer>
                  {Object.keys(userBasicDetailKeyMap).map(key => (
                    <DetailEntry key={key}>
                      {this.state.editMode ? (
                        ''
                      ) : (
                        <DetailTitle edit={this.state.editMode}>
                          {key}
                        </DetailTitle>
                      )}
                      {this.state.editMode
                        ? getEditField(key, userBasicDetailKeyMap)
                        : getDataField(key, userBasicDetailKeyMap)}
                    </DetailEntry>
                  ))}
                  {/*  // <DetailEntry key={key}>
                  //   <DetailTitle edit={this.state.editMode}>{key}</DetailTitle> */}
                </DetailContainer>
                <PersonalDetailHeader>COMPANY DETAILS</PersonalDetailHeader>
                <DetailContainer>
                  {Object.keys(userCompanyDetailKeyMap).map(key => (
                    <DetailEntry key={key}>
                      {this.state.editMode ? (
                        key !== 'Company' ? (
                          <DetailTitle edit={this.state.editMode}>
                            {key}
                          </DetailTitle>
                        ) : (
                          ''
                        )
                      ) : (
                        <DetailTitle edit={this.state.editMode}>
                          {key}
                        </DetailTitle>
                      )}
                      {this.state.editMode
                        ? getEditField(key, userCompanyDetailKeyMap)
                        : getDataField(key, userCompanyDetailKeyMap)}
                    </DetailEntry>
                  ))}
                </DetailContainer>
                <PersonalDetailHeader>PERMISSIONS</PersonalDetailHeader>
                <DetailContainer>
                  {Object.keys(userPermissionKeyMap).map(key => (
                    <DetailEntry key={key} permission>
                      <DetailTitle edit={this.state.editMode}>
                        {key}
                      </DetailTitle>
                      {this.state.editMode
                        ? getEditField(key, userPermissionKeyMap)
                        : getDataField(key, userPermissionKeyMap)}
                    </DetailEntry>
                  ))}
                </DetailContainer>
                {this.state.editMode && (
                  <PersonalDetailHeader>Change Password</PersonalDetailHeader>
                )}
                <DetailContainer>
                  <DetailEntry permission>
                    {this.state.editMode ? <ChangePassword /> : ''}
                  </DetailEntry>
                </DetailContainer>
                {this.state.editMode && (
                  <NitroButtonGroup align="right" layout="horizontal">
                    <NitroButton
                      size="compact"
                      variant="primary"
                      label="Save"
                      icon="save"
                      action={() => {
                        this.setState({
                          editMode: false
                        });
                        saveChange();
                      }}
                    />
                    <NitroButton
                      size="compact"
                      label="Cancel"
                      icon="close"
                      action={() =>
                        this.setState({
                          editMode: false
                        })
                      }
                    />
                  </NitroButtonGroup>
                )}
              </NitroPanel>
            </div>
          ) : (
            <SimpleHolder>
              <NitroLoading center />
            </SimpleHolder>
          )}
        </Container>
      </Main>
    );
  }
}

const mapStateToProps = state => {
  const restrictions = getRestrictions(state);
  const user = getSelectedUser(state);
  const timeZones = getTimeZones(state);
  const roles = getRoles(state);
  const businessEntities = getEntities(state);
  const updateResult = getResult(state);
  return {
    updateResult,
    user,
    roles,
    businessEntities,
    timeZones,
    restrictions,
    loading:
      !user ||
      !timeZones ||
      !timeZones.length ||
      !roles ||
      !businessEntities ||
      !restrictions
  };
};

const mapDispatchToProps = dispatch => ({
  fetchUser: bindActionCreators(fetchUser, dispatch),
  modifyUser: bindActionCreators(updateUser, dispatch),
  turnoffMessage: bindActionCreators(closeMessage, dispatch)
});

UserDetail.contextTypes = {
  router: PropTypes.shape({})
};

UserDetail.propTypes = {
  searchType: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  users: PropTypes.arrayOf(PropTypes.shape({})),
  total: PropTypes.number,
  currentPage: PropTypes.number,
  loading: PropTypes.bool
};

UserDetail.defaultProps = {
  users: [],
  total: 0,
  searchType: 'Role',
  options: SEARCHTYPE.map(i => ({ label: i, value: i })),
  currentPage: 0,
  loading: true
};
export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);



// WEBPACK FOOTER //
// ./src/features/userManagement/UserDetailContainer.js